<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Audit Type List">
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <a @click="$router.push({ name: 'generalMaster' })">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <v-card-text class="pt-0 pr-1"
          :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <!-- <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
            @input="searchHandler()" hide-details single-line style="max-width:350px;" />
          <v-btn class="mr-3" elevation="1" color="success" @click="getAuditType()">
            <v-icon left>mdi-magnify</v-icon>Search
          </v-btn> -->
          <v-btn v-on:click="
              () => {
                $router.push({ name: 'addAuditType' })
              }
            " v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent" right absolute>
            <v-icon left>mdi-plus</v-icon>
            Add Audit Type
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table v-if="lists.length" :headers="headers" :items="lists" disable-pagination
          hide-default-footer>
          <template v-slot:[`item.auditType`]="{ item }">
            <span class="text-capitalize">{{ item.auditType }} </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt"
              @click.prevent="deleteAuditType(item)">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>

          <!-- <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template> -->

        </v-data-table>
        <!--Pagination start-->
        <!-- <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange"> </v-pagination>
          </v-col>
        </v-row> -->
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      isWrite: true,
      search: '',
      tableData: [],
      lists: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      isActive: false,
      headers: [
        { text: 'Sr. No.', value: 'srno', sortable: true },
        { text: 'Name', value: 'auditType', sortable: true },
        { text: 'Updated Date', value: 'createdAt', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  created: async function () {
    await this.getAuditType()
  },
  methods: {
    getAuditType: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-type/get-all-audit-type`)
        console.log(res, 'test')
        this.lists = res.data.map((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
          item.createdAt = moment(item.createdAt).format('DD-MM-YYYY')
          return item
        })
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteAuditType: function (item) {
      let that = this
      this.$dialog.warning({
        title: item.isActive === true ? 'Deactivate' : 'Activate',
        text: 'Are you sure you want to delete this audit type?',
        actions: {
          true: {
            color: 'success',
            text: 'Yes',

            handle: async () => {
              try {
                this.isLoading = true
                return http
                  .put(`${CONSTANTS.API_URL}/api/audit/audit-type/delete-audit-type/${item.id}`, {
                    isActive: item.isActive
                  })
                  .then(() => {
                    that.getAuditType()
                    this.isLoading = false
                    return this.$dialog.info({
                      title: 'Success',
                      text: 'Audit Deleted successfully.'
                    })
                  })
              } catch (httpException) {
                console.warn('Error while deleting Audit Type', httpException.message)
                this.isLoading = false

                return this.$dialog.error({
                  title: 'Error',
                  text: 'Error while Deleting Audit Type'
                })
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
    // handlePageChange: function () {
    //   console.log(`Page: ${this.page}`)
    //   this.getAuditType()
    // },
    // handlePageSizeChange: function () {
    //   console.log(`Page Size: ${this.pageSize}`)
    //   this.getAuditType()
    // },
    // searchHandler: function () {
    //   if (this.search.length > 3) {
    //     this.getAuditType()
    //   }
    // }
  }
}
</script>

<style scoped>
.tooltip-content {
  max-height: 100px;
  overflow-y: scroll;
}
.tooltip-color {
  color: #fff;
  background-color: gray;
}
</style>
